/* unplugin-vue-components disabled */import script from "./formEditOfficialDoc.vue?vue&type=script&setup=true&lang=ts"
export * from "./formEditOfficialDoc.vue?vue&type=script&setup=true&lang=ts"

import "./formEditOfficialDoc.vue?vue&type=style&index=0&id=5225327c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5225327c"]])

export default __exports__